import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { footerLocations, brand } from "../mock";
import { MapPin, Phone, Mail, Facebook, Instagram, Twitter, Clock } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const routeMap = {
  "FAQ": "/page/faq",
  "Refund Policy": "/page/refund-policy",
  "Privacy Policy": "/page/privacy-policy",
  "Terms & Conditions": "/page/terms-conditions",
  "Cancellation Policy": "/page/cancellation-policy",
  "Help Center": "/page/help-center",
  "About Us": "/page/about-us",
  "How It Works": "/page/how-it-works",
  "Become a Beautician": "/become-beautician",
  "Blog": "/blog",
  "Contact Us": "/contact",
};

const serviceCats = ["Facial & Cleanup", "D-Tan & Bleach", "Waxing", "Hair Care", "Manicure-Pedicure", "Makeup"];

const linkCols = [
  { title: "Services", links: serviceCats },
  { title: "Company", links: ["About Us", "How It Works", "Become a Beautician", "Blog", "Contact Us"] },
];

const catSlug = (name) => name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");

const Footer = () => {
  const navigate = useNavigate();
  const [pages, setPages] = useState([]);

  useEffect(() => {
    axios.get(`${API}/pages`).then((res) => setPages(res.data || [])).catch(() => setPages([]));
  }, []);

  const go = (label) => {
    if (routeMap[label]) navigate(routeMap[label]);
    else if (serviceCats.includes(label)) navigate(`/${catSlug(label)}`);
  };
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-12 py-14">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <img src={brand.logo} alt={brand.name} className="h-12 w-auto object-contain bg-white rounded-lg p-1.5" />
            <p className="text-sm text-gray-400 mt-4 max-w-sm">
              Gurugram's premium Salon@Home for women. Trained & verified beauticians, branded products and pocket-friendly offers, delivered to your doorstep.
            </p>
            <div className="mt-5 space-y-2.5 text-sm">
              <a href={`tel:${brand.phoneRaw}`} className="flex items-center gap-2.5 hover:text-white transition-colors"><Phone className="w-4 h-4 text-accent" /> {brand.phone}</a>
              <a href={`mailto:${brand.email}`} className="flex items-center gap-2.5 hover:text-white transition-colors"><Mail className="w-4 h-4 text-accent" /> {brand.email}</a>
              <div className="flex items-center gap-2.5"><Clock className="w-4 h-4 text-accent" /> {brand.hours}</div>
              <div className="flex items-start gap-2.5"><MapPin className="w-4 h-4 text-accent mt-0.5" /> {brand.address}</div>
            </div>
            <div className="flex items-center gap-3 mt-6">
              {[Facebook, Instagram, Twitter].map((Icon, i) => (
                <a key={i} href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-primary flex items-center justify-center transition-colors">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
              <span className="text-sm text-gray-400 ml-1">Follow us {brand.instagram}</span>
            </div>
          </div>

          {linkCols.map((col) => (
            <div key={col.title}>
              <h4 className="text-white font-semibold mb-4">{col.title}</h4>
              <ul className="space-y-2.5 text-sm">
                {col.links.map((l) => (
                  <li key={l}><button onClick={() => go(l)} className="text-gray-400 hover:text-white transition-colors text-left">{l}</button></li>
                ))}
              </ul>
            </div>
          ))}

          <div data-testid="footer-quick-links">
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2.5 text-sm">
              {pages.map((p) => (
                <li key={p.slug}><button onClick={() => navigate(`/page/${p.slug}`)} className="text-gray-400 hover:text-white transition-colors text-left">{p.title}</button></li>
              ))}
            </ul>
          </div>
        </div>

        {/* locations */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <h4 className="text-white font-semibold mb-4">Salon@Home Available In</h4>
          <div className="flex flex-wrap gap-x-5 gap-y-2 text-sm text-gray-400">
            {footerLocations.map((loc) => (
              <a key={loc} href="#" className="hover:text-white transition-colors">{loc}</a>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-12 py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-gray-500">
          <p>© 2024 {brand.name}. All rights reserved.</p>
          <p>Home Salon Services · Beauty for Women · Gurugram</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
